export const baseApiUrl = 'https://redesrurais.org.br/server/'
//export const baseApiUrl = 'http://redesrurais-associados-server.test/'
export const pagseguroURL = 'https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.lightbox.js'
 
export default { baseApiUrl, pagseguroURL }